import X from './collection';
export default X;